import { EmailIntegrationFlow } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

import {
  FlowEmailAddFlowPayloadT,
  FlowEmailGetPayloadT,
  FlowEmailRemovePayloadT,
  FlowEmailUpdateFlowPayloadT,
} from './types';

const base = '/v1/flows';

export function addFlow(payload: FlowEmailAddFlowPayloadT) {
  return ajaxSend<EmailIntegrationFlow>({
    method: 'POST',
    path: base,
    data: payload.flow,
  });
}

export function getFlow(payload: FlowEmailGetPayloadT) {
  return ajaxSend<EmailIntegrationFlow>({
    path: `${base}/${payload.id}`,
  });
}

export function removeFlow(payload: FlowEmailRemovePayloadT) {
  return ajaxSend<EmailIntegrationFlow>({
    method: 'DELETE',
    path: `${base}/${payload.id}`,
  });
}

export function updateFlow(payload: FlowEmailUpdateFlowPayloadT) {
  return ajaxSend<EmailIntegrationFlow>({
    method: 'PUT',
    path: `${base}/${payload.id}`,
    data: payload.flow,
  });
}
